<template>
    <v-content>
      <v-card v-if="!noData">
          <v-toolbar color="secondary" dark>
              <v-toolbar-title :style="$store.state.textFormatting.headers">
                  Prefix last seen {{daysBack}} day(s) ago
              </v-toolbar-title>
                <v-progress-circular v-if="!bubbleData" indeterminate color="white" >
                </v-progress-circular>
              <v-spacer></v-spacer>
                <v-btn fab small color=red @click="addDay()"> <v-icon> arrow_left </v-icon></v-btn>
                    <h3 :style="$store.state.textFormatting.main">Change Days Back</h3>
                <v-btn fab small color=red @click="subtractDay()"> <v-icon> arrow_right </v-icon> </v-btn>
                <v-spacer></v-spacer>
                <downloadcsv
                class   = "btn btn-default"
                :data   = "episodesForPrefix"
                name = "prefixRouting.csv">
                    <v-tooltip top eager color="primary" id="exit-app" v-if="episodesForPrefix">
                        <template v-slot:activator="{ on }">
                            <v-btn small dark v-on="on" color="success" :style="$store.state.textFormatting.main"> <v-icon>save_alt</v-icon> Episodes </v-btn>
                        </template>
                        <span :style="$store.state.textFormatting.main">Download episodes for this prefix</span>
                    </v-tooltip>
                </downloadcsv>
                <v-flex shrink>
                    <v-btn @click="showAll=!showAll" v-if="showAll" dark fab small color="blue"><h2> - </h2></v-btn>
                    <v-btn @click="showAll=!showAll" v-if="!showAll" dark fab small color="blue"><h2> + </h2></v-btn>
                </v-flex>
                <info>
                    <template>
                        Prefix action analysis
                    </template>
                    <template slot="body">
                        <p> The activity of a prefix is important to gain a greater understanding about what is normally expected for this specific prefix</p>
                        <br>
                        <p> This component displays all prefixes in the last day which have involved this prefix and a count of the events for this episode.
                            Using the <i><b>CHANGE DAYS BACK </b></i> episodes for this prefix on different days can be searched.
                            <br> Select an episode from the list to dig deeper into it.
                        </p>
                        <br>
                        <p> Zoom in and out on the table to focus on data points.</p>
                        <br />
                        <b> This queries the episode table, which has a 30 day retention period set </b>
                        <br />
                        <v-divider />
                        <br />
                        <p> <b>Difference between Disaggregation and prefix routing (Prefix last seen 'n' day(s) ago) </b></p>
                        <p> <b>Disaggregation</b>: Looks at the assertion level of the system (prior to events being created), to see when any 
                            <b>parent</b> or <b>child</b> prefix has had it's ownership asserted over. It may or may not have created an event,
                            hence doesn't tie directly to the events created in the system.
                        </p>
                        <p> <b>Prefix routing</b>: Looks only at the prefix of interest, and at the event level of the system (once events <b>have</b> been created).
                            These will therefore have a direct link to the events in the system and can therefore be inspected via the website.
                        </p>
                    </template>
                    <template slot="action">
                        <v-btn color="primary" flat @click="routePrefixRouting" :style="$store.state.textFormatting.main"> More Prefix Routing </v-btn>
                    </template>

                </info>
          </v-toolbar>
          <v-layout justify-center v-if="bubbleData && showAll" wrap>
              
              <v-flex x12 >
                <br />
                <v-card-text>
                    <bubbleGraph :chart-data="bubbleData"  :options="options" :key="id"> </bubbleGraph>
                </v-card-text>
                <br />
              </v-flex>
              <v-flex xs12>
                <v-data-table dense class="elevation-1" :headers="headers" :items="episodesForPrefix"
                        :rows-per-page-items="rowsPerPageItems" :pagination.sync="pagination" v-if="table_buffer">
                    <template slot="headerCell" slot-scope="props">
                        <v-tooltip top eager>
                        <span slot="activator" :style="$store.state.textFormatting.main">
                            {{ props.header.text }}
                        </span>
                        <span :style="$store.state.textFormatting.main">
                            {{ props.header.ad_text }}
                        </span>
                        </v-tooltip>
                    </template>
                    <template slot="items" slot-scope="props">
                        <tr @click="clickHandler(props.item.prefix, 
                            props.item.origin_asn_old, props.item.origin_asn_new, props.item.time_5min, props.item.hijack_score_mean, 
                            props.item.impact_score_mean, props.item.event_count)">
                            <td class="text-xs-center special" :style="$store.state.textFormatting.main">
                                <v-tooltip top eager color="primary" v-if="asn_own_dict[props.item.origin_asn_old]">
                                    <template v-slot:activator="{ on }">
                                        <div v-on="on" :style="$store.state.textFormatting.main">{{ props.item.origin_asn_old }}</div>
                                    </template>
                                    <span :style="$store.state.textFormatting.main"> {{ asn_own_dict[props.item.origin_asn_old] }}</span>
                                </v-tooltip>
                                <div v-if="!asn_own_dict[props.item.origin_asn_old]" :style="$store.state.textFormatting.main"> {{ props.item.origin_asn_old }} <v-progress-circular size="12" indeterminate color="purple" /></div>
                            </td>
                            <td class="text-xs-center special" :style="$store.state.textFormatting.main">
                                <v-tooltip top eager color="primary" v-if="asn_own_dict[props.item.origin_asn_new]">
                                    <template v-slot:activator="{ on }">
                                        <div v-on="on" :style="$store.state.textFormatting.main">{{ props.item.origin_asn_new }}</div>
                                    </template>
                                    <span :style="$store.state.textFormatting.main"> {{ asn_own_dict[props.item.origin_asn_new] }}</span>
                                </v-tooltip>
                                <div v-if="!asn_own_dict[props.item.origin_asn_new]" :style="$store.state.textFormatting.main"> {{ props.item.origin_asn_new }} <v-progress-circular size="12" indeterminate color="purple" /></div>
                            </td>
                            <td class="text-xs-center" :style="$store.state.textFormatting.main"> {{ props.item.hijack_score_mean }}</td>
                            <td class="text-xs-center" :style="$store.state.textFormatting.main"> {{ props.item.impact_score_mean }}</td>
                            <td class="text-xs-center" :style="$store.state.textFormatting.main"> {{ props.item.event_count }}</td>
                            <td class="text-xs-center" :style="$store.state.textFormatting.main"> {{ props.item.datetime_date }}</td>
                            <td class="text-xs-center" :style="$store.state.textFormatting.main"> {{ props.item.datetime_time }}</td>
                        </tr>
                    </template>
                </v-data-table>
            </v-flex>
          </v-layout>
      </v-card>
      <v-card v-if="noData && showAll"> 
          <v-toolbar color="secondary" dark>
              <v-toolbar-title :style="$store.state.textFormatting.main">
                This prefix has not been involved in any episodes prior to this one
              </v-toolbar-title>
          </v-toolbar>
      </v-card>
    </v-content>
</template>

<script>
import { API, graphqlOperation } from 'aws-amplify';
import bubbleGraph from './bubble-graph.js'
import info from '../operational/infopopout.vue'
import downloadcsv from 'vue-json-csv';
import moment from 'moment-timezone';

export default {
    name: 'prefix-routing',
    components: {
        bubbleGraph,
        info,
        downloadcsv
    },
    data () {
        return {
            tz:'UTC',
            noData: null,
            id: 1,
            pagination: {
                    rowsPerPage: 10
                    },
            rowsPerPageItems: [20, 30, 40, 50],
            headers: [
                    { text: 'Old ASN', value:'origin_asn_old', align:'centre', ad_text: ''},
                    { text: 'New ASN', value:'origin_asn_new', align:'centre', ad_text: ''},
                    { text: 'Hijack', value: 'hijack_score_mean', align: 'centre', ad_text: ''},
                    { text: 'Impact', value: 'impact_score_mean', align: 'centre', ad_text: ''},
                    { text: 'Event Count', value: 'event_count', align: 'centre', ad_text: ''},
                    { text: 'Date', value: 'time_5min', align:'centre', ad_text: ''},
                    { text: 'Time', value: 'time_5min', align:'centre', ad_text: ''},
                    ],
            episodesForPrefix: [],
            options: {
                legend: {
                    labels: {
                        // This more specific font property overrides the global property
                        fontSize: this.$store.state.textFormatting.traceroute.fontSize + 10
                    }
                },
                tooltips: {
                        bodyFontSize: this.$store.state.textFormatting.traceroute.fontSize + 10,
                        callbacks: {
                            label: function(tooltipItem, data ) {
                                try {
                                    var eventCount = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].ev_count
                                    if (eventCount ==50) {
                                        eventCount= "50+"
                                    }
                                    var comboScore = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].y
                                    var epochTime = tooltipItem.xLabel
                                    var d_t = new Date( epochTime *1000);
                                    var date = d_t.toLocaleString().substr(0, 10);
                                    var time = d_t.toLocaleString().substr(11, 9);
                                    var label = "Event Count: "+eventCount+", Hijack Score: " +comboScore+", Date: " +date + ", Time: " + time

                                    return label
                                    }
                                    catch(err) {
                                        console.log(err)
                                }
                            }
                        }
                    },
                responsive: true,
                maintainAspectRatio: false,
                //aspectRatio: 0.4,
                scales: {
                    yAxes: [{
                        scaleLabel: {
                            display: true,
                            labelString: 'Hijack Score (H)',
                            fontSize: this.$store.state.textFormatting.traceroute.fontSize + 10
                        },
                        ticks: {
                            beginAtZero:true,
                            max: 99,
                            fontSize: this.$store.state.textFormatting.chart.axis_label
                        }
                    }],
                    xAxes: [{
                        ticks: {
                            fontSize: this.$store.state.textFormatting.chart.axis_label,
                            callback: (value, index, values) => {
                                var dataPointEpochTimeInHRFormat = new Date (value *1000);
                                let dateTime = dataPointEpochTimeInHRFormat.toLocaleString().split(", ");
                                return dateTime[0].split("/")[0] + "/" + dateTime[0].split("/")[1] + " " + dateTime[1].split(":")[0] + ":" + dateTime[1].split(":")[1];  
                            }
                        }
                    }]
                },
                pan: {
                    enabled: true,
                    mode: 'x',
                    passive: true
                },
                zoom: {
                    enabled: true,
                    mode: 'x',
                    passive: true
                }
            },
            bubbleData: null,
            prefix: "160.202.161.0/24",
            daysBack: 0,
            loadup: true,
            showAll: true,
            distinct_colors: [
                '#e6194b', 
                '#3cb44b', 
                '#ffe119', 
                '#4363d8', 
                '#f58231', 
                '#911eb4', 
                '#46f0f0', 
                '#f032e6', 
                '#bcf60c', 
                '#fabebe', 
                '#008080', 
                '#e6beff', 
                '#9a6324', 
                '#fffac8', 
                '#800000', 
                '#aaffc3', 
                '#808000', 
                '#ffd8b1', 
                '#000075', 
                '#808080', 
                //'#ffffff', remove white
                '#000000'
            ],
            asn_own_dict: {},
            asn_get_owner: [],
            table_buffer: true
        }
    },
    props: ['prefixProp'],
    mounted () {
        this.getEpisodesForPrefix(this.prefixProp,this.daysBack)
       // console.log(this.prefixProp)
    },
    methods: {
        routePrefixRouting: async function () {
            this.$router.push({ name: 'Prefix Routing', 
                        params: {prefix: this.prefixProp}})
        },
        getEpisodesForPrefix: async function (prefix, daysBack) {
            var query = `query getEpisodesForPrefix { getEpisodesForPrefix(prefix: "`+prefix+`", daysBack: `+daysBack+`) {
                            prefix
                            origin_asn_new
                            origin_asn_old
                            hijack_score_mean
                            impact_score_mean
                            event_count
                            time_5min
                            }
                        }`
            
            
            let  getEpisodesForPrefix  = await API.graphql(graphqlOperation(query));
            //console.log(query);
            var episodeForPrefix = getEpisodesForPrefix.data.getEpisodesForPrefix
            //console.log(episodeForPrefix);
            if (this.loadup == true) {
                while(episodeForPrefix.length == 0 && daysBack < 31) {
                    daysBack= daysBack+1
                    var query2 = `query getEpisodesForPrefix { getEpisodesForPrefix(prefix: "`+prefix+`", daysBack: `+daysBack+`) {
                                prefix
                                origin_asn_new
                                origin_asn_old
                                hijack_score_mean
                                impact_score_mean
                                event_count
                                time_5min
                                }
                            }`
//                    console.log(query2);
                    getEpisodesForPrefix  = await API.graphql(graphqlOperation(query2));
                    var episodeForPrefix = getEpisodesForPrefix.data.getEpisodesForPrefix
//                    console.log(episodeForPrefix);
                    this.daysBack = daysBack          
                    if (episodeForPrefix ==true) {
                        this.noData = false
                    } else if (episodeForPrefix ==false && daysBack==31){
                        this.noData= true
                    }
                }
            }

            
            var tempEpNoZero =[]
            for (var p=0; p< episodeForPrefix.length; p=p+1) {

                episodeForPrefix[p].origin_asn_old = episodeForPrefix[p].origin_asn_old.toString()
                episodeForPrefix[p].origin_asn_new = episodeForPrefix[p].origin_asn_new.toString()

                if (!this.asn_get_owner.includes(episodeForPrefix[p].origin_asn_old.toString())) {
                    this.asn_get_owner.push(episodeForPrefix[p].origin_asn_old);
                }
                if (!this.asn_get_owner.includes(episodeForPrefix[p].origin_asn_new.toString())) {
                    this.asn_get_owner.push(episodeForPrefix[p].origin_asn_new);
                }

                if (episodeForPrefix[p].event_count > 0) {
                    var pp = this.convertEpochtoTimeDate(episodeForPrefix[p].time_5min)
                    episodeForPrefix[p].datetime_date = pp.date
                    episodeForPrefix[p].datetime_time = pp.time.trimLeft()
                    tempEpNoZero.push(episodeForPrefix[p])
                }

                if (p == episodeForPrefix.length - 1) {
                    this.getASNOwners()
                }
            }
            this.episodesForPrefix = tempEpNoZero

            
            var bubbleData = this.createBubbleDatasets(episodeForPrefix)
            this.bubbleData = bubbleData
            this.loadup=false
            
        }, 
        getAnASNOwner: async function(asn) {
            //console.log("getting asn owner: " + asn)
            if (asn == 0 || asn == 'N/A') {
                return "None";
            } else if (asn == 'Restricted Prefix') {
                return "Restricted Prefix"
            } else {
                try {
                    var qry = `query getASNOwner { getASNOwner ( asn: "` +
                    asn +
                    `" ) {
                            organisation
                        }
                    }`;
                    //console.log(qry);
                    const res = await API.graphql(graphqlOperation(qry));
                    var ownData = res.data.getASNOwner;
                    //console.log(ownData);
                    if (ownData) {
                        if (ownData.length > 0) {
                        //console.log("owner: ");
                        //console.log(ownData[0].organisation);
                            if (ownData[0].organisation) {
                                return ownData[0].organisation;
                            } else {
                                return "Unknown";
                            }
                        } else {
                            return "Unknown";
                        }
                    } else {
                        return "Unknown";
                    }
                } catch (err) {
                    console.log(err);
                    return "Unknown";
                }
            }
        },
        getASNOwners: async function () {
            
            //console.log("gettign asn owners")
            var nero = {}
            for ( var i = 0 ; i < this.asn_get_owner.length ; i++ ) {
                var keys = Object.keys(this.asn_own_dict)
                if (!(keys.includes((this.asn_get_owner[i]).toString()))) {
                    nero[this.asn_get_owner[i]] = this.getAnASNOwner(this.asn_get_owner[i])
                }
            }
            for ( var i = 0 ; i < this.asn_get_owner.length ; i++ ) {
                
                
                //console.log("GETTING AN OWNER")
                if (!(keys.includes((this.asn_get_owner[i]).toString()))) {
                    this.asn_own_dict[this.asn_get_owner[i]] = await nero[this.asn_get_owner[i]]
                }
                
                if ( i == this.asn_get_owner.length - 1 ) {
                    this.table_buffer = false;
                    this.$nextTick(() => {
                        // Add the component back in
                        this.table_buffer = true;
                    });
                }
            }
        },
        subtractDay: function() {
            this.daysBack = this.daysBack-1
            this.getEpisodesForPrefix(this.prefixProp,this.daysBack)
        },
        addDay: function() {
            this.daysBack = this.daysBack+1
            this.getEpisodesForPrefix(this.prefixProp,this.daysBack)
        },
        createBubbleDatasets: function(data) {
            //DatasetLabel = origin_asn_new
            // y = hijack_score_mean * impact_score_mean
            // x = time_5min
            // r = event_count

            
            var asnList = []
            for (var j = 0; j< data.length; j = j+1) {
                 asnList.push(data[j].origin_asn_new)
            }
            var uniqueASNs = asnList.filter(this.onlyUnique)
            //console.log(uniqueASNs)
            var bubbleData = {
                datasets: []
            }
            var col_used = 0;
            uniqueASNs.sort()
            for (var asnCount = 0; asnCount < uniqueASNs.length; asnCount=asnCount+1) {
                var datasetFull = {label: uniqueASNs[asnCount], data: [], 
                backgroundColor: this.distinct_colors[col_used]}
                col_used += 1;
                bubbleData.datasets.push(datasetFull)
            }
            for (var i=0; i < data.length; i = i+1) {
                for (var asn=0; asn< uniqueASNs.length; asn=asn+1) {
                    if (data[i].origin_asn_new == bubbleData.datasets[asn].label){
                        var score_combo = data[i].hijack_score_mean
                        if ( data[i].event_count > 50 ) {
                            var bubblesize = 30
                        } else {
                            var bubblesize = Math.round(data[i].event_count * 27/30) + 3
                        }
                        var dataset = {x: data[i].time_5min, y: score_combo, r: bubblesize, ev_count: data[i].event_count}
                        bubbleData.datasets[asn].data.push(dataset)
                        
                    }
                }  
            }

            return bubbleData
        },
        onlyUnique: function (value, index, self) { //returns unique values in a list

            return self.indexOf(value) === index;
        },
        convertEpochtoTimeDate: function (epochTime) {
            try {
        //        var d_t = new Date(epochTime * 1000);

        //        var date = d_t.toLocaleString().substr(0, 10);
        //        var time = d_t.toLocaleString().substr(11, 9);

                var dateFormatted = moment.unix(epochTime).tz(this.tz).format('DD/MM/YYYY')
                var timeFormatted = moment.unix(epochTime).tz(this.tz).format('HH:mm:ss')
                var dateTime = { date: dateFormatted, time: timeFormatted, epoch: epochTime };

                return dateTime;                }
            catch(err) {
                console.log(this.tz)
                console.log(epochTime)
                console.log(err)
            }

        },
        clickHandler: function (prefix, old_asn, new_asn, time, h, i , event_count) {
            var paramatersCombined = prefix+"~"+old_asn+"~"+new_asn+"~"+time+"~"+h+"~"+i+"~"+event_count
            //var paramatersCombined = prefix+"~"+old_asn+"~"+new_asn+"~"+time
            let routeData = this.$router.resolve({
                name: "Alert From Top 10",
                params: { prefix: paramatersCombined }
            });
            window.open(routeData.href, "_blank");
        }
  },

}
</script>

<style scoped>

    tbody tr:nth-of-type(even) {
      background-color: rgba(0, 0, 0, .05);
    }

    .v-table tr:hover:not(.v-table__expanded__content) {
        background-color: rgba(0, 0, 0, .4);
    }

</style>